module.exports = __webpack_public_path__ + "img/task6.d72ef8a6.png";